<template>
  <div>
    <el-button type="primary" @click="downloadwechatPdf">打印退款申请单</el-button>
  </div>
</template>

<script>
const Base64 = require('js-base64').Base64
import { html2pdf } from '../../request/apis';
import { chatHtml } from '../../utils/wechatpdf';

export default {
  name: 'TicChatPdf',
  props:{
    DataValue:{
      type:Object,
      default:()=>{}
    },
  },
  data() {
    return {
      apiHost: 'https://gateuat.sgsonline.com.cn',
    }
  },
  methods: {
    downloadwechatPdf(){
      html2pdf({
        fileContent: Base64.encode(chatHtml(this.DataValue)),
      }, `${this.DataValue.orderNumber}退款申请.pdf`, this.apiHost, this, 'btnLoading')
    },
  }
};
</script>

<style scoped>

</style>
